const LAZY_LOAD_VIEW = (path) => () =>
  import(
    /* webpackChunkName: "view-operations-vocational-rehabilitation-referral-[request]" */ `@/views/pei/vocational-rehabilitation-referral/${path}`
  );

export default [
  {
    path: 'vocational-rehabilitation-referral',
    component: LAZY_LOAD_VIEW`Wrapper.vue`,
    children: [
      {
        path: '',
        name: 'vocational-rehabilitation-referral',
        component: LAZY_LOAD_VIEW`Main.vue`,
      },
      {
        path: ':id',
        name: 'vocational-rehabilitation-referral-manage',
        props: true,
        component: LAZY_LOAD_VIEW`manage/Main.vue`,
      },
    ],
  },
];
